import { render, staticRenderFns } from "./columnadd.vue?vue&type=template&id=e2791d06&scoped=true&"
import script from "./columnadd.vue?vue&type=script&lang=js&"
export * from "./columnadd.vue?vue&type=script&lang=js&"
import style0 from "./columnadd.vue?vue&type=style&index=0&id=e2791d06&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2791d06",
  null
  
)

component.options.__file = "columnadd.vue"
export default component.exports